export default __webpack_public_path__ + "static/media/email.d005780f.png";